import React from "react";
import { useIntl } from "react-intl";
import { MemoizedDefaultChip } from "../../../components/chip/ChipRenderer.js";
import { ChipVariant, ChipType } from "../../../components/chip/types.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
const BulkTotalCountChip = ({ processedItems, totalItems, affectedEntityName, chipType }) => {
  const { formatMessage } = useIntl();
  const total = processedItems > 0 && totalItems > 0 ? `${processedItems}/${totalItems}` : totalItems ? `${totalItems}` : "0";
  const chipMapping = {
    info: ChipVariant.Disabled,
    infoDark: ChipVariant.DarkGrey,
    warning: ChipVariant.Orange,
    warningDark: ChipVariant.OrangeDark,
    success: ChipVariant.Green,
    successDark: ChipVariant.GreenDark
  };
  const formattedType = affectedEntityName ? formatMessage(affectedEntityName) : "";
  return /* @__PURE__ */ React.createElement(MemoizedDefaultChip, { value: `${total} ${formattedType}`, variant: chipMapping[chipType], type: ChipType.Status });
};
export {
  BulkTotalCountChip
};
//# sourceMappingURL=BulkTotalCountChip.js.map
